import { createSlice } from '@reduxjs/toolkit';

const exportSlice = createSlice({
  name: 'importSlice',
  initialState: {
    data: [],
    displayLoader: true,
    isDataLoaded: false
  },
  reducers: {
    handleData: (state, action) => {
      state.data = action.payload;
    },
    handleDisplayLoader: (state, action) => {
      state.displayLoader = action.payload;
    },
    handleIsDataLoaded: (state, action) => {
      state.isDataLoaded = action.payload;
    }
  }
});

export const { handleData, handleDisplayLoader, handleIsDataLoaded } = exportSlice.actions;

export default exportSlice.reducer;
